import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components/macro";

const NewBreadCrumb = ({ items }) => {
  const navigate = useNavigate();
  return (
    <BreadCrumbWrap>
      {items.map((item, index) => (
        <div key={index}>
          <span
            onClick={() => {
              item.url && navigate(item.url);
            }}
            style={{
              marginLeft: index === 0 ? 0 : "16px",
              marginRight: index === items.length - 1 ? 0 : "16px",
            }}
          >
            {item.label}
          </span>
          {index !== items.length - 1 && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="5"
              height="5"
              viewBox="0 0 5 5"
              fill="none"
              style={{ marginBottom: "2px" }}
            >
              <circle cx="2.94141" cy="2.91406" r="2" fill="#919EAB" />
            </svg>
          )}
        </div>
      ))}
    </BreadCrumbWrap>
  );
};

export default NewBreadCrumb;

const BreadCrumbWrap = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 16px;
    font-family: var(--roboto-500);
    color: #637381;
    cursor: pointer;

    :last-child {
      color: #212b36;
      cursor: unset;
    }
  }
`;
